import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { withParams } from '@telialt/utils/src/helpers';

import { ORDER_CART_TEST_ID } from '../../constants';
import { PreorderBannerData } from '../../model';
import { PreorderStatusBar } from './PreorderBanner.styles';

export const PreorderBanner: FC<PreorderBannerData> = ({ shipmentDate }) => {
    const { t } = useTranslations();

    return (
        <PreorderStatusBar data-test={ORDER_CART_TEST_ID.PREORDER_BANNER}>
            {withParams(t['order_cart.preorder_banner.text'], { date: shipmentDate })}
        </PreorderStatusBar>
    );
};
